import { useSelector, shallowEqual } from 'react-redux';
import State, { OptimizelyDecisionsSlice } from 'types/State';

export default function useOptimizelyDecisions(): OptimizelyDecisionsSlice {
  const session = useSelector<State, OptimizelyDecisionsSlice>(
    (state) => state.optimizelyDecisions,
    shallowEqual
  );

  return session;
}
